import { memo, RefAttributes } from 'react';
import { TextArea as RACTextArea, TextAreaProps as RACTextAreaProps } from 'react-aria-components';

import { merge } from '@/components';
import { DivProps } from '@/utils';

export type TextAreaProps = RACTextAreaProps &
  RefAttributes<HTMLTextAreaElement> & {
    props?: {
      container?: DivProps;
    };
  };

const ITextArea = ({ className, children, props, ...rest }: TextAreaProps) => {
  /* prettier-ignore */
  const containerStyles = [
    'bg-white',
    'border-1',
    'border-gray-200',
    'flex',
    'font-regular',
    'has-[:disabled]:bg-gray-50',
    'items-center',
    'min-h-8',
    'outline-none',
    'p-2',
    'rounded-md',
    'shadow-xs',
    'w-full',
  ];

  /* prettier-ignore */
  const styles = [
    'bg-none',
    'data-[disabled]:bg-gray-50',
    'data-[disabled]:cursor-not-allowed',
    'data-[disabled]:text-gray-500',
    'font-medium',
    'grow',
    'outline-none',
    'text-gray-700',
    'text-sm',
  ];

  /* prettier-ignore */
  const lightStyles = [
    'placeholder:text-gray-400',
    'text-gray-900',
  ];

  const { className: containerClassName, ...containerProps } = props?.container ?? {};

  return (
    <div className={merge(containerStyles, containerClassName)} {...containerProps}>
      <RACTextArea className={merge(styles, lightStyles, className)} {...rest} />
      {children}
    </div>
  );
};

export const TextArea = memo(ITextArea) as typeof ITextArea;
